import React, { FunctionComponent } from "react";

import SmartBandImage from "nvent-web/assets/CertifiedProOffers/smartband-russian-offer.png";

import style from "./RussianSmartBandOffer.module.scss";

export const RussianSmartBandOffer: FunctionComponent = () => (
  <>
    <h3>
      Зарегистрируй первый монтаж «теплого пола» nVent RAYCHEM в приложении Install PRO360 и получи в подарок умный
      браслет XIAOMI Mi Smart Band 4
    </h3>
    <h4 className={style.header}>Как получить подарок?</h4>
    <ol>
      <li>Приобрети «теплый пол» nVent RAYCHEM</li>
      <li>Установи «теплый пол» </li>
      <li>
        Создай «проект» в InstallPRO360
        <ul>
          <li>cфотографируй раскладку кабеля </li>
          <li>приложи фото чека вместе с фотографиями с объекта</li>
        </ul>
      </li>
    </ol>
    <span className={style.smallText}>
      Не забывайте указывать номер телефона для уточнения адреса отправки подарков!
    </span>
    <h4 className={style.header}>Мы отправим подарки всем, кто правильно и аккуратно оформил проект в приложении!</h4>
    <ul>
      <li>Участникам, зарегистрировавшим проекты до 30 ноября 2020, подарки будут отправлены до 15 декабря 2020</li>
      <li>Участникам, зарегистрировавшим проекты до 28 декабря 2020, подарки будут отправлены до 30 января 2021</li>
    </ul>
    <p className={style.italicText}>
      Акция действует до 31 декабря 2020 г. либо до момента окончания подарков на складе. Акция может быть продлена на
      усмотрение Организатора. В акции могут принять участие сертифицированные и несертифицированные монтажники,
      работающие на территории Российской Федерации и Республики Беларусь.
    </p>
    <p className={style.italicText}>
      Принимая участие в акции, участник дает свое согласие на обработку своих персональных данных (в том числе фамилии,
      имени, отчества, пола, возраста, номера мобильного телефона, адреса места жительства, электронного адреса и проч.)
    </p>
    <img className={style.image} src={SmartBandImage} alt="smartband" />
  </>
);
